// Bootstrap 5 の data-bs-toggle="tooltip" を持つ要素を有効化する。
// 詳細: .spec/DESIGN-tier4-b-tier2-polish.md §4-4
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  if (window._bootstrapTooltipsInit) return;
  window._bootstrapTooltipsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof bootstrap === 'undefined') return;
    var triggers = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    triggers.forEach(function (el) { new bootstrap.Tooltip(el); });
  });
})();
